import API from './services/api'
import { notification } from './services/notification'

export default class ButtonDeleteReservation {
  constructor() {
    const buttons = document.querySelectorAll('[data-delete-reservation]')
    // console.log('ButtonDeleteReservation', buttons, notification)

    buttons.forEach((e) => {
      e.addEventListener('click', (event) => {
        event.preventDefault()

        notification.confirm.require({
          header: 'Confirmare',
          message: 'Ești sigur că vrei să renunți la rezervare?',
          rejectProps: {
            label: 'Nu',
            severity: 'secondary',
            outlined: true,
          },
          acceptProps: {
            label: 'Șterge',
            severity: 'danger',
          },
          accept: async () => {
            e.classList.add('is-loading')

            try {
              await API.removeTicket({
                ticket_id: parseInt(e.dataset.id),
              })

              window.location.reload()
            } catch (error) {
              notification.toast.add({
                summary: 'Eroare',
                detail: error.message,
                severity: 'error',
                life: 2000,
              })
            } finally {
              e.classList.remove('is-loading')
            }
          },
        })
      })
    })
  }
}
